import { gql } from '@apollo/client';

import { USER_FRAGMENT } from '../fragments';

export const GET_REPORTS = gql`
  query GetReports {
    reports {
      id
      title
      year
      framework
      progress
    }
  }
`;

export const GET_REPORTS_BY_COMPANY_ID = gql`
  query GetReportsByCompanyId($companyId: ID!) {
    reportsByCompanyId(companyId: $companyId) {
      id
      title
      year
      framework
      progress
    }
  }
`;

export const GET_REPORT_BY_ID = gql`
  query GetReportById($reportId: ID!) {
    report(reportId: $reportId) {
      id
      title
      year
      framework
      progress
    }
  }
`;

export const GET_REPORT_DETAILS = gql`
  query GetReportDetails($language: LanguageCode!, $reportId: ID!) {
    reportSections(language: $language) {
      id
      reportChapter {
        id
        title
        area
        label
        framework
        label
      }
      title
      mandatoryRequirements
      mandatoryRequirementsIntroductionPhase
      voluntaryRequirements
      voluntaryRequirementsInIntroductoryPhase
      framework
      frameworkTitle
      example
    }
    reportInputs(reportId: $reportId) {
      id
      input
      isGenerating
      isMarkedCompleted
      reportSectionId
      isMaterial
      assignedTo {
        ...userValues
      }
    }
  }
  ${USER_FRAGMENT}
`;

export const GET_REPORT_INPUTS = gql`
  query DownloadReport($reportId: ID!) {
    downloadReport(reportId: $reportId) {
      id
      reportChapterId
      reportChapter {
        id
        title
        framework
      }
      title
      input
    }
  }
`;

export const REPORT_CHAPTERS = gql`
  query ReportChapters {
    reportChapters {
      id
      title
      framework
      label
    }
  }
`;
